/**
 * Full Width Testimonial Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initFullWidthTestimonial() {
        const blocks = document.querySelectorAll('.full-width-testimonial');
        
        blocks.forEach(block => {
            // Add your block functionality here
            console.log('[BLOCK] full-width-testimonial block initialized');
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFullWidthTestimonial);
    } else {
        initFullWidthTestimonial();
    }
})();